/**
 * ProspectsSettings — top-level container for the three config pages.
 * Sub-tabs: Stages, Tasks, Disclosures.
 */

import { useState } from 'react';
import { GitBranch, ListChecks, FileText } from 'lucide-react';
import StagesConfig from './settings/StagesConfig';
import TasksConfig from './settings/TasksConfig';
import DisclosuresConfig from './settings/DisclosuresConfig';

type SettingsTab = 'stages' | 'tasks' | 'disclosures';

const subTabs: Array<{ id: SettingsTab; label: string; icon: typeof GitBranch }> = [
  { id: 'stages', label: 'Stages', icon: GitBranch },
  { id: 'tasks', label: 'Tasks', icon: ListChecks },
  { id: 'disclosures', label: 'Disclosures', icon: FileText },
];

export default function ProspectsSettings() {
  const [tab, setTab] = useState<SettingsTab>('stages');

  return (
    <div>
      <div className="bg-gray-50 rounded-lg p-1 inline-flex gap-1 mb-4">
        {subTabs.map((t) => {
          const Icon = t.icon;
          const isActive = tab === t.id;
          return (
            <button
              key={t.id}
              onClick={() => setTab(t.id)}
              className={`flex items-center gap-1.5 px-3 py-1.5 text-sm rounded-md transition-colors ${
                isActive
                  ? 'bg-white text-gray-900 shadow-sm'
                  : 'text-gray-600 hover:text-gray-900'
              }`}
            >
              <Icon className="w-4 h-4" />
              {t.label}
            </button>
          );
        })}
      </div>

      <div>
        {tab === 'stages' && <StagesConfig />}
        {tab === 'tasks' && <TasksConfig />}
        {tab === 'disclosures' && <DisclosuresConfig />}
      </div>
    </div>
  );
}
